var _style, _g, _circle, _circle2, _circle3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImage05Layer1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_5",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 750 573",
    style: {
      enableBackground: "new 0 0 750 573"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st0{opacity:.3}.st1{fill:#00cbd8}.st2{fill:#fffa02}.st3{fill:#ffcd00}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M588.7 261.9c-8.4.0-15.2-6.8-15.2-15.2s6.8-15.2 15.2-15.2 15.2 6.8 15.2 15.2C603.9 255.1 597.1 261.9 588.7 261.9zM588.7 233.9c-7.1.0-12.9 5.8-12.9 12.9s5.8 12.9 12.9 12.9 12.9-5.8 12.9-12.9S595.8 233.9 588.7 233.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M588.8 272.9c-9.2.0-18.1-4.8-22.9-13.4-7-12.6-2.5-28.6 10.1-35.6 6.1-3.4 13.2-4.2 19.9-2.3s12.3 6.3 15.7 12.4c7 12.6 2.5 28.5-10.1 35.6l-.7-1.3.7 1.3C597.4 271.8 593.1 272.9 588.8 272.9zM588.7 223.6c-3.9.0-7.8 1-11.2 2.9-11.1 6.2-15.1 20.4-8.9 31.5 6.2 11.1 20.3 15.1 31.5 8.9v0c11.1-6.2 15.1-20.4 8.9-31.5-3-5.4-8-9.3-13.9-11C592.9 223.9 590.8 223.6 588.7 223.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M588.7 292.8c-20.9.0-39.9-14.4-44.8-35.6-5.8-24.7 9.7-49.5 34.4-55.3 12-2.8 24.3-.8 34.8 5.8s17.7 16.7 20.5 28.6c5.8 24.7-9.7 49.5-34.4 55.3v0C595.6 292.4 592.1 292.8 588.7 292.8zM588.8 204.4c-3.2.0-6.5.4-9.7 1.1-22.7 5.3-36.9 28.1-31.6 50.8s28.1 36.9 50.8 31.6v0c22.7-5.3 36.9-28.1 31.6-50.9-2.6-11-9.3-20.4-18.9-26.4C604.3 206.5 596.6 204.4 588.8 204.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M588.7 314c-33.4.0-62.4-25-66.7-58.9-4.6-36.8 21.6-70.4 58.4-75 36.8-4.6 70.4 21.6 75 58.4s-21.6 70.4-58.4 75v0C594.2 313.8 591.4 314 588.7 314zM588.8 183.9c-2.6.0-5.2.2-7.8.5-34.4 4.3-58.9 35.7-54.7 70.2 4.3 34.4 35.7 59 70.1 54.6 34.4-4.3 58.9-35.7 54.7-70.1C647.2 207.2 620 183.9 588.8 183.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M588.6 335.5c-21.4.0-41.8-7.6-58.1-21.8-17.9-15.6-28.7-37.2-30.3-60.8-3.4-48.8 33.5-91.3 82.4-94.8 48.8-3.4 91.3 33.5 94.8 82.4 3.4 48.8-33.5 91.3-82.4 94.8C592.8 335.4 590.7 335.5 588.6 335.5zM588.8 162.9c-2 0-3.9.1-5.9.2-46.1 3.2-81 43.3-77.7 89.4 1.6 22.3 11.7 42.7 28.6 57.4 16.9 14.7 38.5 21.9 60.8 20.4v0c46.1-3.2 81-43.3 77.7-89.4C669.2 196.8 632.3 162.9 588.8 162.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M588.6 357.2c-28 0-54.5-10.4-75.1-29.5-21.6-20.1-34.1-47.4-35.2-76.9s9.4-57.6 29.4-79.3c20.1-21.6 47.4-34.1 76.9-35.2s57.7 9.4 79.3 29.4 34.2 47.4 35.2 76.9-9.3 57.6-29.4 79.3c-20.1 21.6-47.4 34.1-76.9 35.2v0C591.4 357.2 590 357.2 588.6 357.2zM588.8 141.9c-1.3.0-2.7.0-4 .1-28 1-53.9 12.9-72.9 33.4s-29 47.2-27.9 75.2c1 28 12.9 53.9 33.4 72.9 20.5 19 47.2 29 75.2 27.9v0c28-1 53.9-12.9 72.9-33.4s29-47.2 27.9-75.2c-1-28-12.9-53.9-33.4-72.9C640.5 151.8 615.3 141.9 588.8 141.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M588.7 379c-72 0-131.1-58-132.2-130.2-.5-35.3 12.7-68.8 37.3-94.1 24.6-25.4 57.6-39.7 92.9-40.2.7.0 1.4.0 2.1.0 72 0 131.1 58 132.2 130.2 1.1 72.9-57.3 133.2-130.2 134.3C590.1 379 589.4 379 588.7 379zM590.7 372.7v3.2V372.7c69.4-1.1 125.1-58.5 124-127.9-1.1-68.8-57.4-124-125.9-124-.7.0-1.3.0-2 0-33.6.5-65.1 14.1-88.5 38.3-23.4 24.1-36 56-35.5 89.6 1.1 68.8 57.4 124 125.9 124C589.3 372.7 590 372.7 590.7 372.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M588.7 400.9c-85 0-154.1-69.1-154.1-154.1S503.7 92.6 588.7 92.6s154.1 69.1 154.1 154.1S673.7 400.9 588.7 400.9zM588.7 99.6c-81.1.0-147.1 66-147.1 147.1s66 147.1 147.1 147.1 147.1-66 147.1-147.1S669.8 99.6 588.7 99.6z"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 392,
    cy: 157,
    r: 150
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 588.7,
    cy: 246.7,
    r: 16.5
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 580.9,
    cy: 434.8,
    r: 65.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage05Layer1);
export default __webpack_public_path__ + "static/media/image-05-layer-1.bd5a9f9a1f31828120dbdf84d1280ee6.svg";
export { ForwardRef as ReactComponent };